
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  CommunityQmiDetails, HeaderData, NeighborhoodPlanQmiCounts, NeighborhoodSoldDetails, QmiDays, SidebarHomePlan, planDetails,
} from '@/types';
import ArrowDownIcon from "@/assets/icons/ArrowDown.vue";
import RangeSlider from './modal/RangeSlider.vue';
import { HomePlanSortOptions, QmiDaysFilter, SliderChange, OrderHomeTypeList, UrlFilterList, Settings, HomeType } from '@/constant'
import { compareSortingValue } from '@/core/funcs';
import { isMobile, isTablet } from 'mobile-device-detect';
@Component({
  components: {
    ArrowDownIcon,
    RangeSlider
  },
})
export default class PlatmapCommunityDetails extends Vue {
  private showPlanName = false;
  private showPriceRange = false;
  private showHomeType = false;
  private listHomeType = [] as string[];
  private listPlanName = [] as string[];
  private listPlanId = [] as string[];
  // private initialListPlanName=[] as string[];
  // private initialHomeType= [] as string[];
  private minRangeOnSlider = 0;
  private maxRangeOnSlider = 0;
  private showMinRangeOnSlider = 0;
  private showMaxRangeOnSlider = 0;
  private minValueAfterChangeOnSlider = 0;
  private maxValueAfterChangeOnSlider = 0;
  private initialMin = Settings.MinValue;
  private initialMax = Settings.MaxValue;
  private homeTypeList = new Set<string>();
  // private showPlaneNameCount = false;
  // private showHomeTypeCount = false;
  private disableFilters = false;
  private initialPlanCount = 0;
  private allPlansSelected = false;
  private planNameQmiList =[] as planDetails[];
  homePlanSortOptions = HomePlanSortOptions;
  qmiDaysFilter = QmiDaysFilter;
  private hasMobile = !!(isMobile && !isTablet);
  private urlMaxPrice = '';
  private urlMinPrice = '';
  @Prop() headerData!: HeaderData;
  @Prop() availableSites!: number;
  @Prop() availablePlans!: number;
  @Prop() qmiAndHomeplans!: any[];
  @Prop() availableLots!:number;
  @Prop() selectedNeighborhoodIds!: string[];
  @Prop() planPriceExsist!: boolean;
  @Prop() private qmiDetails!:CommunityQmiDetails;
  @Prop() soldPercentage!: NeighborhoodSoldDetails[];
  @Prop() neighborhoodsPlanQmiCount!: NeighborhoodPlanQmiCounts[];
  @Prop() communityHomePlans!: SidebarHomePlan[];
  @Prop() initialHomePlanCount!: number;
  @Prop() filterQmiCount!: number;
  @Prop() qmiFilter!: boolean;
  @Prop() qmiAppliedMobile!: boolean;
  @Prop() homeTypeCount!: number;
  created() {
    this.getHomeTypeList();
    this.calculateMinMaxPriceRange();
    this.communityHomePlans.sort((field1,field2)=>compareSortingValue(field1.plan_name, field2.plan_name))
    this.setPlanDetailsHometypeList(this.communityHomePlans, this.homeTypeList, this.minRangeOnSlider,this.maxRangeOnSlider);
  }
  mounted() {
    this.initialPlanCount = this.availablePlans;
    this.checkFilterConditions();
    const planId = [] as string[];
    this.communityHomePlans.forEach((homePlan)=> {
      this.planNameQmiList.push(
        {
          plan_id:homePlan.plan_id,
          plan_name:homePlan.plan_name
        });
      planId.push(homePlan.plan_id)
    });
    for(const key of Object.keys(this.qmiDetails)){
      this.qmiDetails[key].forEach((qmi)=> {
        if(!planId.includes(qmi.plan_code)){
          this.planNameQmiList.push(
            {
              plan_id:qmi.plan_code,
              plan_name:qmi.plan_market_name
            })
            planId.push(qmi.plan_code)
        }
      });
    }
    this.urlQueryFilters();
    this.urlSortFilter();
  }

  queryFilterExsist(urlFilterData: string[], planHomeList: planDetails[] | Set<string> ){
    if(Array.isArray(planHomeList)){
      urlFilterData= urlFilterData.filter((element)=> planHomeList.find((data)=> data.plan_name === element));
    }else{
      urlFilterData= urlFilterData.filter((element)=> planHomeList.has(element));
    }
    return urlFilterData;
  }

  checkPriceInRange(minPrice: number,maxPrice: number){
    if(minPrice >= maxPrice){
      return true;
    }else if(!(minPrice > this.minRangeOnSlider && minPrice < this.maxRangeOnSlider) &&
    !(maxPrice > this.minRangeOnSlider && maxPrice < this.maxRangeOnSlider)){
      return true;
    }
    return false;
  }

  accurateUrlPrice(minPrice: number,maxPrice: number){
    if(this.checkPriceInRange(minPrice, maxPrice)){
      minPrice = this.minRangeOnSlider;
      maxPrice = this.maxRangeOnSlider;
    }else if(minPrice % SliderChange  || maxPrice % SliderChange ){
      minPrice = parseInt(this.changeMaxMinPriceRange(minPrice));
      maxPrice = minPrice + SliderChange;
    }
    return {
      minPrice,
      maxPrice
    };
  }

  checkHomeTypeApplicable() {
    if(this.homeTypeCount < 2) {
      this.updateQueryFilter(UrlFilterList.HOME_TYPE);
    }
  }
  urlQueryFilters(){
    this.urlMaxPrice = this.$route.query[UrlFilterList.MAX_PRICE] as string;
    this.urlMinPrice = this.$route.query[UrlFilterList.MIN_PRICE] as string;
    const filteredHomePlans= this.$route.query[UrlFilterList.PLAN_NAME];
    if(filteredHomePlans && Array.isArray(filteredHomePlans)){
      this.listPlanName = this.queryFilterExsist(filteredHomePlans as string[], this.planNameQmiList);
    }else if(filteredHomePlans){
      this.listPlanName = this.queryFilterExsist([filteredHomePlans], this.planNameQmiList);
    }
    this.checkHomeTypeApplicable();
    const filteredHomeTypes = this.$route.query[UrlFilterList.HOME_TYPE];
    if(filteredHomeTypes && Array.isArray(filteredHomeTypes)){
      this.listHomeType = this.queryFilterExsist(filteredHomeTypes as string[], this.homeTypeList);
    }else if(filteredHomeTypes){
      this.listHomeType = this.queryFilterExsist([filteredHomeTypes], this.homeTypeList);
    }
    this.urlQmiFilter();
  }

  urlPriceFilter(){
    let correctMinPrice = Settings.MinValue;
    let correctMaxPrice = Settings.MaxValue;
    if(this.urlMaxPrice){
      correctMaxPrice = parseInt(this.urlMaxPrice)
    }
    if(this.urlMinPrice){
      correctMinPrice = parseInt(this.urlMinPrice)
    }
    if(correctMaxPrice !== Settings.MaxValue && correctMinPrice !== Settings.MinValue && !this.conditionShowPriceRange  && !this. planPriceExsist){
      const correctMinMax = this.accurateUrlPrice(correctMinPrice, correctMaxPrice);
      this.initialMin= correctMinMax.minPrice;
      this.initialMax= correctMinMax.maxPrice;
      if(this.hasMobile && (this.initialMin !== this.minRangeOnSlider || this.initialMax!=this.maxRangeOnSlider)){
        this.applyMobilePriceFilter(this.initialMin, this.initialMax)
      }
      this.applyPriceFilter(this.initialMin, this.initialMax);
    }else{
        this.updateQueryFilter(UrlFilterList.MAX_PRICE);
        this.updateQueryFilter(UrlFilterList.MIN_PRICE);
    }
  }
  urlSortFilter(){
    const sortType = this.$route.query[UrlFilterList.SORT_BY];
    const sortOtion = this.homePlanSortOptions.find((option)=> option.value === sortType);
    if(sortOtion){
      this.setSorting(sortOtion);
    }else{
      this.updateQueryFilter(UrlFilterList.SORT_BY);
    }
  }

  urlQmiFilter(){
    const qmiList = this.$route.query[UrlFilterList.QMI_FILTER] as string[];
    const qmiDaysFilterList = qmiList ? this.qmiDaysFilter.filter((data)=> qmiList.includes(data.value)) : [];
    if(qmiDaysFilterList.length){
      this.applyUrlQmi(qmiDaysFilterList);
    }else{
      this.updateQueryFilter(UrlFilterList.QMI_FILTER);
    }
    if(this.hasMobile && (this.listPlanName.length || this.listHomeType.length || qmiDaysFilterList.length)){
      this.applyMobileFilters(this.listPlanName, this.listHomeType,qmiDaysFilterList);
    }
  }

  updateQueryFilter(filterType: string){
    const newQuery= {...this.$route.query};
    newQuery[filterType] = [];
    this.$router.push({query: newQuery}).catch(()=>{});
  }

  get updateQmiFilter(){
    return `${this.qmiFilter} ${this.filterQmiCount} ${this.availablePlans} ${this.qmiAppliedMobile}`
  }

  @Watch("updateQmiFilter")changePlanCount(){
    if (this.qmiFilter || this.qmiAppliedMobile) {
      this.initialPlanCount = this.filterQmiCount;
    } else {
      this.initialPlanCount = this.availablePlans;
    }
  }

  @Watch("homeTypeCount") changeHomeTypeList() {
    if(this.homeTypeCount < 2){
      this.listHomeType = [];
    }
  }

  @Watch("listHomeType")
  @Watch("listPlanName") listPlanUpdates() {
    this.allPlansSelected = this.listPlanName.length === this.planNameQmiList.length;
    if(!this.hasMobile){
      this.applyFilter();
    }
  }

  get showHomeSitesCount() {
    if (this.selectedNeighborhoodIds.length) {
      const neighborhoodData = this.headerData.sibling.find((neighborhood) => neighborhood.id === this.selectedNeighborhoodIds[0]);
      return neighborhoodData?.home_type && !(HomeType.includes(neighborhoodData.home_type.toLowerCase()))
    }else{
      return !! (this.headerData.sibling.find((neighborhood) => !HomeType.includes(neighborhood.home_type.toLowerCase())));
    }
  }


  get conditionShowPriceRange() {
    if(!this.initialHomePlanCount) {
      return true;
    }
    if (this.selectedNeighborhoodIds.length) {
      const currentSoldPercentage = this.soldPercentage.filter((element) => this.selectedNeighborhoodIds.includes(element.neighborhoodId));
      return (currentSoldPercentage.length) ? currentSoldPercentage[0].soldPercentage >= 100 : true;
    } else {
      const currentSoldPercentage = this.soldPercentage.filter((element) => element.soldPercentage<100);
      return !currentSoldPercentage.length;
    }
  }
  @Emit("filterPlanNameHomeType") filterPlanNameHomeType(listHomeType: string[], listPlanName: string[], maxPrice: number, minPrice: number) {
  }
  @Emit("setSorting") setSorting(option: any) {}
  @Emit("setPlanNameListId") setPlanNameListId(listPlanId: string[]) {}
  @Emit("loadNeighborhood") loadNeighborhood(
    areaName: string,
    communityName: string,
    neighborhoodName: string
  ) {}
  @Emit("applyUrlQmi")applyUrlQmi(qmFilterList:QmiDays[]){}
  @Emit("applyMobileFilters")applyMobileFilters(listPlanName:string[],listHomeType:string[],qmiFilterList:QmiDays[]){}
  @Emit("setPlanDetailsHometypeList")setPlanDetailsHometypeList(communityHomePlans: SidebarHomePlan[],homeTypeList: Set<string>, minPrice: number, maxPrice: number){}
  @Watch("selectedNeighborhoodIds") neighborhoodChanged(newVal: string[], oldVal: string[]) {
    if(newVal !== oldVal) {
      this.checkFilterConditions();
    }
  }
  @Emit("applyMobilePriceFilter") applyMobilePriceFilter(minValue: number,maxValue: number){}
  @Watch("soldPercentage") neighborhoodCountUpdate() {
    this.checkFilterConditions();
    this.urlPriceFilter();
  }
  get setFormatForPriceRange() {
    const minData = this.minValueAfterChangeOnSlider + '';
    const maxData = this.maxValueAfterChangeOnSlider + '';
    const minDataToShowOnSelectorPanel = (minData).substring(0, minData.length -3 );
    const maxDataToShowOnSelectorPanel = (maxData).substring(0, maxData.length -3 );
    return `$${minDataToShowOnSelectorPanel}k-$${maxDataToShowOnSelectorPanel}k`;
  }

  checkFilterConditions() {
    if (this.selectedNeighborhoodIds.length) {
      const selectedNeighborhoodId = this.selectedNeighborhoodIds[0];
      if (this.soldPercentage.find((neighborhood) => neighborhood.neighborhoodId === selectedNeighborhoodId)?.totalLotsCount) {
        const requiredNeighborhoodData = this.neighborhoodsPlanQmiCount.find(neighborhood => neighborhood.neighborhoodId === selectedNeighborhoodId);
        const planQmisCount = requiredNeighborhoodData ? requiredNeighborhoodData.neighborhoodPlansCount + requiredNeighborhoodData.neighborhoodQmisCount : 0;
        this.disableFilters = !planQmisCount ;
      } else {
        this.disableFilters = true;
      }
    } else {
      // const zeroHomePlanQmiCountNeighborhood = this.neighborhoodsPlanQmiCount.find((neighborhood) => neighborhood.neighborhoodPlansCount + neighborhood.neighborhoodQmisCount === 0);
      const zeroHomePlanQmiCountNeighborhood = this.neighborhoodsPlanQmiCount.find((neighborhood) => neighborhood.neighborhoodPlansCount + neighborhood.neighborhoodQmisCount !== 0);
      this.disableFilters = !(zeroHomePlanQmiCountNeighborhood);
      if (this.disableFilters) {
        // const zeroLotCountNeighborhood = this.soldPercentage.find((neighborhood) => neighborhood.totalLotsCount === 0);
        const zeroLotCountNeighborhood = this.soldPercentage.find((neighborhood) => neighborhood.totalLotsCount !== 0);
        // this.disableFilters = zeroLotCountNeighborhood ? true: false;
        this.disableFilters = !zeroLotCountNeighborhood;
      }
    }
  }

  selectAllPlans() {
    this.listPlanId = [];
    this.listPlanName = [];
    if(!this.allPlansSelected) {
      this.planNameQmiList.forEach((plan) => {
        this.listPlanId.push(plan.plan_id);
        this.listPlanName.push(plan.plan_name);
      });
    }
    this.allPlansSelected = !this.allPlansSelected;
  }

  applyFilter () {
    this.filterPlanNameHomeType(this.listHomeType, this.listPlanName, this.initialMax, this.initialMin);
  }
  hideDropDown(e: Event) {
    const planName = document.querySelector('.planName');
    const priceRange = document.querySelector('.priceRange');
    const homeType = document.querySelector('.homeType');
    if (planName && !planName.contains(e.target as Node)) {
      this.showPlanName = false;
      // this.listPlanName = this.initialListPlanName;
    }
    if (priceRange && !priceRange.contains(e.target as Node)) {
      this.showPriceRange = false;
    }
    if (homeType && !homeType.contains(e.target as Node)) {
      this.showHomeType = false;
      // this.listHomeType = this.initialHomeType;
    }
  }
  calculateMinMaxQmiDetails()
  {
    let remainingNeighborhoodQmiMin = Settings.MaxValue;
    let remainingNeighborhoodQmiMax = Settings.MinValue;
    for(const key of Object.keys(this.qmiDetails))
    {
        remainingNeighborhoodQmiMin = this.qmiDetails[key].reduce((oldVal, newVal)=> (newVal.price>0) ? Math.min(oldVal, newVal.price) : oldVal, remainingNeighborhoodQmiMin);
        remainingNeighborhoodQmiMax =  this.qmiDetails[key].reduce((oldVal, newVal) => Math.max(oldVal, newVal.price), remainingNeighborhoodQmiMax);
    }
    return {
      min: remainingNeighborhoodQmiMin,
      max: remainingNeighborhoodQmiMax
    };
  }
  calculateMinMaxPriceRange()
  {
    this.minRangeOnSlider = this.communityHomePlans.reduce((oldVal, newVal)=>{
    const price = newVal.price_low_with_premium;
    return ((price>0) ? Math.min(oldVal,price):oldVal)} , Settings.MaxValue);
    this.maxRangeOnSlider = this.communityHomePlans.reduce((oldVal, newVal) => Math.max(oldVal,  newVal.price_low_with_premium), Settings.MinValue);
    const qmiMinMax=this.calculateMinMaxQmiDetails();
    this.minRangeOnSlider=Math.min(this.minRangeOnSlider,qmiMinMax.min);
    this.maxRangeOnSlider=Math.max(this.maxRangeOnSlider,qmiMinMax.max);
    this.minRangeOnSlider = parseInt(this.changeMaxMinPriceRange(this.minRangeOnSlider));
    this.showMinRangeOnSlider = this.minRangeOnSlider;
    let maxSliderValueAsPerSetup = this.minRangeOnSlider;
    while (maxSliderValueAsPerSetup < this.maxRangeOnSlider) {
      maxSliderValueAsPerSetup += SliderChange;
    }
    this.maxRangeOnSlider = maxSliderValueAsPerSetup;
    this.showMaxRangeOnSlider = this.maxRangeOnSlider;
    window.addEventListener('click', this.hideDropDown);
  }
  addListPlanId(planId: string) {
    const index = this.listPlanId.indexOf(planId);
    if (index >= 0) {
      this.listPlanId.splice(index, 1)
    } else {
      this.listPlanId.push(planId)
    }
  }
  clearPriceFilter(minShow: number, maxShow: number) {
    this.minValueAfterChangeOnSlider = minShow;
    this.maxValueAfterChangeOnSlider = maxShow;
    this.showMinRangeOnSlider = this.minRangeOnSlider;
    this.showMaxRangeOnSlider = this.maxRangeOnSlider;
    this.initialMax = Settings.MaxValue;
    this.initialMin = Settings.MinValue;
    this.applyFilter();
  }
  clearPlanName() {
    // this.initialListPlanName=[];
    this.listPlanName = [];
    this.listPlanId = [];
    this.setPlanNameListId(this.listPlanId);
    // this.showPlaneNameCount = false;
    this.applyFilter();
  }
  clearHomeType()
  {
    // this.showHomeTypeCount = false;
    this.listHomeType = [];
    // this.initialHomeType = [];
    this.applyFilter();
  }
  applyPriceFilter(minShow: number, maxShow: number) {
    this.minValueAfterChangeOnSlider = minShow;
    this.maxValueAfterChangeOnSlider = maxShow;
    this.showMinRangeOnSlider = this.initialMin = minShow;
    this.showMaxRangeOnSlider = this.initialMax = maxShow;
    this.applyFilter();
  }
  
  clearAllFilters() {
    this.clearPriceFilter(0,0);
    this.clearHomeType();
    this.clearPlanName();
  }
  closePriceRange(){
    this.showPriceRange = false;
  }

  applyPlanNameFilter()
  {
    if(this.listPlanName.length){
      // this.initialListPlanName = this.listPlanName;
      this.showPlanName = false;
      // this.setPlanNameListId(this.listPlanId);
      // this.showPlaneNameCount = true;
      // this.applyFilter();
    }
  }
  applyHomeTypeFilter()
  {
    if (this.listHomeType.length) {
      // this.initialHomeType = this.listHomeType
      // this.showHomeTypeCount = true;
      this.showHomeType = false;
      // this.applyFilter();
    }
  }
  changeMaxMinPriceRange(minValue: number)
  {
    const stringMinMaxValue = minValue+'';
    let changedMinRangeSliderAsPerStep;
    if(stringMinMaxValue.length <= 6)
    {
      +(stringMinMaxValue.substring(1,2)) >= 5?
      changedMinRangeSliderAsPerStep=stringMinMaxValue.substring(0,1)+"5"+("0".repeat((this.minRangeOnSlider+'').length-2)):
      changedMinRangeSliderAsPerStep=stringMinMaxValue.substring(0,1)+("0".repeat(stringMinMaxValue.length-1))
    }else{
      +(stringMinMaxValue.substring(2,3)) >=5 ?
      changedMinRangeSliderAsPerStep=stringMinMaxValue.substring(0,2)+"5"+("0".repeat(stringMinMaxValue.length-3)):
      changedMinRangeSliderAsPerStep=stringMinMaxValue.substring(0,2)+("0".repeat(stringMinMaxValue.length-2))
    }
    return changedMinRangeSliderAsPerStep;
  }

  sortHomeTypeList(){
    const sortedHomeTypeList = new Set<string>();
    for(const eachHomeType of OrderHomeTypeList){
      if(this.homeTypeList.has(eachHomeType)){
        sortedHomeTypeList.add(eachHomeType);
      }
    }
    this.homeTypeList = sortedHomeTypeList ;
  }
  getHomeTypeList()
  {
    for(const homePlan of this.communityHomePlans)
    {
      this.homeTypeList.add(homePlan.plan_type);
    }
    for(const key of Object.keys(this.qmiDetails))
    {
      for(const eachQmi of this.qmiDetails[key]){
        this.homeTypeList.add(eachQmi.plan_type);
      }
    }
    this.sortHomeTypeList();
  }
}
